<template lang="pug">
    .animation(ref='animation')
        svg(width='238' height='305' viewbox='0 0 238 305')
            g.cube
                path(d='M139.182 38.1746L72.9991 0L6.81641 38.1746L72.9991 76.3492L139.182 38.1746Z' fill='black')
                path(d='M77.8164 161L143.999 122.825V46.4761L77.8164 84.6192V161Z' fill='black')
                path(d='M2 46.4761V122.825L68.2142 161V84.6192L2 46.4761Z' fill='black')
            g.cube
                path(d='M233.36 160.876L181.565 131L129.77 160.876L181.565 190.752L233.36 160.876Z' fill='black')
                path(d='M185.334 257L237.129 227.124V167.373L185.334 197.224V257Z' fill='black')
                path(d='M126 167.373V227.124L177.82 257V197.224L126 167.373Z' fill='black')
            g.cube
                path(d='M107.36 208.876L55.5647 179L3.76953 208.876L55.5647 238.752L107.36 208.876Z' fill='black')
                path(d='M59.334 305L111.129 275.124V215.373L59.334 245.224V305Z' fill='black')
                path(d='M0 215.373V275.124L51.8198 305V245.224L0 215.373Z' fill='black')
</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/mixinAnimation';

export default {
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            this.createTimeline();
            this.createScroll('top-bottom', 'bottom-top');
        },
        createTimeline() {
            this.timeline = gsap.timeline({paused: true});
            let cubes = this.$refs.animation.querySelectorAll('.cube');
            this.timeline
                .fromTo(cubes, {opacity: 0}, {duration: 0.5, opacity: 1, ease: 'none', stagger: {each: 1}}, 0)
                .fromTo(cubes, {opacity: 1}, {duration: 0.5, opacity: 0, ease: 'none', stagger: {each: 1}}, 2);
            this.timeline.progress(0.0001);
            this.timeline.pause();
        }
    }
};
</script>
<style lang="scss" scoped>
.animation {
    display: flex;
    align-items: center;
    justify-content: center;
}
.knife {
    padding: 20px 0;
}
</style>
